import { render } from "./DashboardBaldZuErledigen.pug?vue&type=template&id=08ac0f67&lang=pug"
import script from "./DashboardBaldZuErledigen.js?vue&type=script&lang=js"
export * from "./DashboardBaldZuErledigen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__